import {AbstractControllerException} from 'core/abstract/AbstractControllerException';
import {Redirect} from 'next';
export interface IRedirectControllerExceptionProps {
    destination: string;
    statusCode: Extract<Redirect, {statusCode: number}>['statusCode'];
}

export class RedirectControllerException
    extends AbstractControllerException
    implements IRedirectControllerExceptionProps
{
    public destination: string;
    public statusCode: IRedirectControllerExceptionProps['statusCode'];
    constructor(message: string, {destination, statusCode}: IRedirectControllerExceptionProps) {
        super(message);

        this.destination = destination;
        this.statusCode = statusCode;
    }

    public makeNextControllerObject(): Record<'redirect', Redirect> {
        return {
            redirect: {
                destination: this.destination,
                statusCode: this.statusCode,
            },
        };
    }
}
